export const METACATEGORY_ITEMS_LIMIT = 2000;
